import React, { useState } from "react";
import AdminTopBar from "../Common/AdminTopBar";
import { navigate } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { api_handler } from "../../services/api";


const Add = () => {

  const [interfaceName, setInterfaceName] = useState("");
  const [interfaceDesc, setInterfaceDesc] = useState("");
  const [interfaceSubdomain, setInterfaceSubdomain] = useState("");

  const createInterface = async () => {
    var data = {
      "name": interfaceName,
      "desc": interfaceDesc,
      "subdomain": interfaceSubdomain
  };
    const api_rsp = await api_handler("int:create", data, "POST");
    if(api_rsp.code===200) { 
      navigate("/interfaces/"+api_rsp.data.uuid+"/view/")
     
     }

  };

  


  const handleInterfaceName = (event) => {
    setInterfaceName(event.target.value);
  };

  const handleInterfaceDesc = (event) => {
    setInterfaceDesc(event.target.value);
  };

  const handleInterfaceSubDomain = (event) => {
    setInterfaceSubdomain(event.target.value);
  };



  return (
    <div>
      <AdminTopBar />
      <div className="section__master">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 lg:col-span-12 xxl:col-span-12">
            <div className="Section__body">
              <div className="intro-y box">
                <div className="flex items-center  pt-0 border-b border-gray-200">
                  <h2 className="font-medium text-base mr-auto">
                    Create A New Interface
                  </h2>
                </div>
                <div className="p-5">
                  <div className="intro-y box lg:mt-5">
                    <div className="card card-form mt-3">
                      <div className="row no-gutters">
                        <div className="col-lg-3 card-body">
                          <p>
                            <strong className="upl_hdr">
                              Basic Interface Details
                            </strong>
                          </p>
                          <p className="upl_txt">
                            Just these few things are required for us to create your very own Interface including, stub data sandbox, developer portal and API suite.
                          </p>
                        </div>
                        <div className="col-lg-9 card-form__body card-body d-flex align-items-center">
                          <div className="col-lg-12 card-form__body card-body  align-items-center">
                            <div className="col-span-12 lg:col-span-12 xxl:col-span-12">
                              <form
                                id="page_form"
                                className="col-span-12 xl:col-span-12"
                                novalidate="novalidate"
                              >
                                <div className="form-group">
                                  <div className="mt-3">
                                    <label htmlFor="interface_name" className="flex flex-col sm:flex-row">
                                      Interface Name
                                      <span
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        title=""
                                        data-original-title="Provide a name for your Interface - this will be visible to your users and account providers"
                                      >
                                        &nbsp;&nbsp;&nbsp;
                                        <i className="ti-info-alt text-primary"></i>
                                      </span>
                                      <span className="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                                        * Mandatory
                                      </span>
                                    </label>
                                    <input
                                      type="text"
                                      id="interface_name"
                                      className="input w-full border mt-2"
                                      placeholder="Interface Name"
                                      name="interface_name"
                                      onChange={handleInterfaceName}
                                    />
                                  </div>
                                </div>

                                <div className="form-group">
                                  <div className="mt-3">
                                    <label htmlFor="interface_desc" className="flex flex-col sm:flex-row">
                                      Interface Description
                                      <span
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        title=""
                                        data-original-title="Provide a description for your Interface - this will be visible to your users and account providers"
                                      >
                                        &nbsp;&nbsp;&nbsp;
                                        <i className="ti-info-alt text-primary"></i>
                                      </span>
                                      <span className="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                                        * Mandatory
                                      </span>
                                    </label>
                                    <textarea
                                      id="interface_desc"
                                      className="input w-full border mt-2"
                                      name="interface_desc"
                                      rows="4"
                                      placeholder="Interface Description"
                                      cols="50"
                                      onChange={handleInterfaceDesc}
                                    ></textarea>
                                  </div>
                                </div>

                                <div className="form-group">
                                  <div className="mt-3">
                                    <label htmlFor="interface_website" className="flex flex-col sm:flex-row">
                                      Interface Developer Portal Subdomain
                                      <span
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        title=""
                                        data-original-title="Provide a URL for users to return to after completing authorisation with their account provider. This is the location on your application that will receive a returned user and which you will need to configure to complete the process as described in our documentation. Don’t worry - this can be changed at any time"
                                      >
                                        &nbsp;&nbsp;&nbsp;
                                        <i className="ti-info-alt text-primary"></i>
                                      </span>
                                      <span className="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                                        * Mandatory
                                      </span>
                                    </label>
                                    <input
                                      type="text"
                                      id="interface_website"
                                      className="input w-full border mt-2"
                                      placeholder="Interface Developer Portal Subdomain e.g. your_brand will create https://your_brand.tell.money"
                                      name="interface_website"
                                      onChange={handleInterfaceSubDomain}
                                    />
                                  </div>
                                </div>

                                <div className="text-left mt-5">
                                  <button
                                    className="cca-btn"
                                    id="login_button"
                                    type="button"
                                    onClick={createInterface}
                                  >
                                    <div>
                                      CREATE<span></span>
                                      <i className="sbmt_but_icon">
                                        <FontAwesomeIcon icon={faSave} />
                                      </i>
                                    </div>
                                    <span></span>
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
